"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentAsText = void 0;
const cycles_1 = require("../formatters/cycles");
function getContentAsText(content) {
    let text;
    if (content.kind === "text") {
        text = content.text;
    }
    else if (content.kind === "media") {
        text = buildTextForMediaContent(content);
    }
    else if (content.kind === "file") {
        text = content.name;
    }
    else if (content.kind === "cycles") {
        text = cycles_1.formatCycles(content.amount);
    }
    else {
        throw new Error("Unrecognised content type - " + content.kind);
    }
    return text.trim();
}
exports.getContentAsText = getContentAsText;
function buildTextForMediaContent(content) {
    if (content.caption)
        return content.caption;
    const mimeType = content.mimeType;
    const mimeTypeLower = mimeType.toLowerCase();
    if (mimeTypeLower.startsWith("video/")) {
        return "video";
    }
    else if (mimeTypeLower.startsWith("image/")) {
        return "image";
    }
    else {
        return "file";
    }
}
